import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/file.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-db499b3a")

_pushScopeId("data-v-db499b3a")
const _hoisted_1 = {
  class: "pt-4 w-full flex flex-col gap-3",
  "data-testid": "bulk-booking-create-client-layout"
}
const _hoisted_2 = { class: "border border-gray-lp-1300 rounded-xl p-3" }
const _hoisted_3 = {
  class: "flex flex-row gap-3 items-center font-semibold",
  "data-testid": "bulk-booking-create-title-upload-file"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  class: "w-6",
  src: _imports_0
}, null, -1)
const _hoisted_5 = { class: "flex-shrink-0" }
const _hoisted_6 = { class: "border border-gray-lp-1300 rounded-md p-3" }
const _hoisted_7 = /*#__PURE__*/_createVNode("hr", { class: "my-5 border-gray-lp-400" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_upload_file = _resolveComponent("upload-file")!
  const _component_data_wrapper = _resolveComponent("data-wrapper")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_download_template = _resolveComponent("download-template")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_DetailLayout, {
      onBack: _ctx.goBack,
      title: _ctx.$t('bulkBooking.create.title'),
      "vertical-separator": false,
      fullPage: "",
      usePaddingVertical: false,
      customClass: "pr-0"
    }, {
      "top-right": _withId(() => []),
      data: _withId(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode("div", _hoisted_2, [
            _createVNode(_component_data_wrapper, null, {
              label: _withId(() => [
                _createVNode("div", _hoisted_3, [
                  _hoisted_4,
                  _createTextVNode(" " + _toDisplayString(_ctx.$t("bulkBooking.create.uploadFileTitle")), 1)
                ])
              ]),
              default: _withId(() => [
                _createVNode(_component_upload_file, {
                  id: "upload-file",
                  type: "xlsx",
                  titleChange: _ctx.$t('bulkBooking.create.change'),
                  captionHtml: 
                _ctx.$t('bulkBooking.create.uploadFileCaption', {
                  maxStt: _ctx.maximumStt,
                  maxMb: _ctx.maximumFileSize
                })
              ,
                  "data-testid": "bulk-booking-create-text-filename",
                  isDraggable: false,
                  modelValue: _ctx.form.archiveFile,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.archiveFile = $event)),
                  errorMessage: _ctx.$t('bulkBooking.create.uploadFileErrorFormat'),
                  draggable: "xlsx",
                  customClass: "border border-solid"
                }, null, 8, ["titleChange", "captionHtml", "modelValue", "errorMessage"])
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              "data-testid": "booking-bulk-create-label-activity-name",
              label: _ctx.$t('bulkBooking.create.activityName'),
              class: "w-full",
              style: {"margin-top":"11px"}
            }, {
              default: _withId(() => [
                _createVNode(_component_LpInput, {
                  type: "text",
                  errorIcon: false,
                  placeholder: _ctx.$t('bulkBooking.create.activityNamePlaceholder'),
                  maxLength: "56",
                  minLength: "3",
                  modelValue: _ctx.form.activityName,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.activityName = $event)),
                  onChange: _ctx.onChangeActivityName,
                  errorMessageMinLength: _ctx.$t('bulkBooking.create.validationChars'),
                  showMaxLength: "",
                  "data-testid": "booking-bulk-create-input-activity-name"
                }, null, 8, ["placeholder", "modelValue", "onChange", "errorMessageMinLength"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_LpButton, {
              "data-testid": "bulk-booking-create-button-upload",
              title: _ctx.$t('bulkBooking.create.upload'),
              "text-color": "white",
              isWidthFull: "",
              id: "button_upload_bulk_booking",
              disabled: _ctx.isBulkUploadValid,
              onClick: _ctx._onAdd
            }, null, 8, ["title", "disabled", "onClick"])
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode(_component_download_template, {
                "download-layout-column": "2-column",
                title: _ctx.$t('bulkBooking.create.downloadTemplate'),
                description: _ctx.$t('bulkBooking.create.downloadTemplateHint'),
                typeDownload: "download-template",
                dataComponent: _ctx.templateBookingData
              }, null, 8, ["title", "description", "dataComponent"]),
              _hoisted_7,
              _createVNode(_component_download_template, {
                downloadLayoutColumn: "2-column",
                title: _ctx.$t('bulkBooking.create.checkFormatTitle'),
                description: _ctx.$t('bulkBooking.create.checkFormatHint'),
                typeDownload: "cek-format",
                dataComponent: _ctx.templateComodityData
              }, null, 8, ["title", "description", "dataComponent"])
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["onBack", "title"]),
    _withDirectives(_createVNode(_component_Modal, {
      title: _ctx.$t('bulkBooking.create.uploadSuccessTitle'),
      onSubmit: _ctx.closePageUploadBulkBooking,
      message: _ctx.messageModalBookingOnProcess,
      image: "scan-cargoV2-badges/success",
      textSuccess: _ctx.$t('bulkBooking.create.btnUnderstand'),
      class: "px-8",
      customButton: "w-full",
      customParentButton: "w-full",
      customWrapperButton: "w-80"
    }, null, 8, ["title", "onSubmit", "message", "textSuccess"]), [
      [_vShow, _ctx.resultUpload]
    ]),
    _withDirectives(_createVNode(_component_Modal, {
      title: _ctx.errorTitle,
      onSubmit: _ctx.onSubmitFailedUploadBulkBooking,
      onClose: _ctx.onCloseUploadBulkBooking,
      message: _ctx.errorSubtitle,
      image: "ill_badge_failed",
      textSuccess: _ctx.btnModalFailed,
      textCancel: _ctx.btnModalCancel,
      class: "px-8",
      customButton: "w-full",
      customParentButton: "w-full",
      customWrapperButton: "w-80"
    }, null, 8, ["title", "onSubmit", "onClose", "message", "textSuccess", "textCancel"]), [
      [_vShow, _ctx.resultErrorUpload]
    ])
  ], 64))
})